<button
  type="button"
  class="product-feature-upgrade-button"
  (click)="onComparePlansClicked()"
>
  {{
    (labelKey ? translationService.getTranslationForKey(labelKey) : null)
      | subscribe
  }}
</button>
